@if (mobileOpen()) {
  <div
    aria-hidden="true"
    class="fixed inset-0 z-40 bg-black/50 lg:hidden"
    data-testid="menu-backdrop"
    (click)="closeMobileMenu()"
  ></div>
}

<div
  class="flex flex-col h-full overflow-hidden transition-transform duration-300 ease-in-out w-screen lg:w-56 border-r border-white/10 fixed inset-y-0 left-0 z-50 lg:relative lg:inset-auto bg-primary-500"
  [ngClass]="mobileOpen() ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'"
  >
  <header class="flex h-12 shrink-0 items-center justify-between border-b border-white/10 px-2 w-full box-border">
    <img
      class="h-auto max-w-[5.5rem] w-full object-contain brightness-0 invert opacity-90"
      alt="liga"
      width="112"
      height="20"
      [ngSrc]="'/assets/images/logo.webp'"
      >

      <button
        lButton
        bContent="icon"
        bSize="small"
        bType="light"
        outline
        type="button"
        class="block lg:hidden !border-white/40 hover:!bg-white/10"
        (click)="closeMobileMenu()"
        aria-label="Fechar menu"
        >
        <l-icon class="text-inherit" icon="close" aria-hidden="true" />
      </button>
    </header>

    <nav
      role="navigation"
      class="relative flex-1 min-h-0 m-0 mb-0 flex flex-col px-2 py-1"
      aria-label="Menu principal"
      >
      <div
        class="pointer-events-none absolute inset-x-2 bottom-1 z-[1] h-7 bg-gradient-to-t from-primary-500 from-15% to-transparent to-100%"
        aria-hidden="true"
      ></div>
      <ul class="menu-nav-scroll relative z-0 m-0 min-h-0 flex-1 list-none space-y-0.5 pb-5 overflow-y-auto scroll-smooth p-0 py-0.5 pr-1">
        @for (group of menuGroups; track $index) {
          @if (group.label) {
            <li class="list-none px-1 pt-7 pb-1.5 first:pt-1" data-testid="menu-group-label">
              <l-text
                t="small3"
                tone="mist90"
                strong="semibold"
                flow="block"
                class="text-[9px] uppercase tracking-wide opacity-75"
              >
                {{ group.label }}
              </l-text>
            </li>
          }
          @for (menu of group.items; track menu.key ?? menu.title) {
            <li>
              <ng-container *ngTemplateOutlet="menuItem; context: { menu, index: menuIndex(menu) }" />
            </li>
          }
        }
      </ul>
    </nav>

    <footer class="shrink-0 px-2 pb-2 pt-0">
      <div class="relative w-full rounded-xl overflow-hidden bg-basic-100 ring-2 ring-white/70 shadow-xl p-3.5 flex flex-col justify-between mb-2">
        <div class="absolute inset-0 pointer-events-none overflow-hidden">
          <svg
            class="absolute -right-6 -top-6 h-[130%] w-[130%] text-primary-500/30"
            viewBox="0 0 240 240"
            fill="none"
            aria-hidden="true"
            >
            <path
              d="M-20 200 C60 140 120 180 260 40"
              stroke="currentColor"
              stroke-width="1.2"
              stroke-opacity="0.55"
              fill="none"
              />
            <path
              d="M40 260 C100 120 180 100 280 -20"
              stroke="currentColor"
              stroke-width="1"
              stroke-opacity="0.35"
              fill="none"
              />
            <path
              d="M-30 120 C40 80 140 60 270 20"
              stroke="currentColor"
              stroke-width="0.9"
              stroke-opacity="0.4"
              fill="none"
              />
            <path
              d="M20 240 C80 160 160 140 300 60"
              stroke="currentColor"
              stroke-width="0.85"
              stroke-opacity="0.32"
              fill="none"
              />
            <path
              d="M220 -10 C160 50 100 130 0 200"
              stroke="currentColor"
              stroke-width="1"
              stroke-opacity="0.28"
              fill="none"
              />
            <path
              d="M180 250 C220 180 240 100 260 0"
              stroke="currentColor"
              stroke-width="0.75"
              stroke-opacity="0.38"
              fill="none"
              />
          </svg>
        </div>

        <div class="relative z-[1] w-9 h-9 mb-2 rounded-full bg-primary-100 ring-1 ring-primary-200 flex items-center justify-center">
          <l-icon class="text-primary-500 text-[20px]" aria-hidden="true" icon="menu_book" />
        </div>

        <div class="relative z-[1] mb-2">
          <l-text t="body2" tone="default" strong="semibold">
            Precisa de ajuda?
          </l-text>
          <l-text t="body3" tone="muted" flow="block" class="mt-0.5">
            Consulte a documentação
          </l-text>
        </div>

        <button
          lButton
          bSize="small"
          bType="primary"
          class="relative z-[1]"
          (click)="openDocs()"
          aria-label="Abrir documentação"
          >
          <l-text t="body2" tone="white" flow="inline-block" class="ml-1 whitespace-nowrap">Documentação</l-text>
        </button>
      </div>

        <!-- <div class="flex justify-between items-center cursor-pointer">
            <l-icon class="w-10 text-text-400" src="assets/images/liga-footer.svg" />
            <span class="text-text-400 text-xs">v1.0.0</span>
          </div>-->
    </footer>
  </div>

  <ng-template #menuItem let-menu="menu" let-index="index">
    @if (menu.wip) {
      <span
        class="flex w-full cursor-default items-center gap-2.5 rounded-lg border-r-4 border-transparent px-3 py-2 text-white/60"
        [attr.aria-label]="menu.title + ' (em desenvolvimento)'"
        aria-disabled="true"
      >
        <span class="flex h-5 w-5 shrink-0 items-center justify-center">
          <l-icon class="text-[18px] leading-none text-primary-200/80" aria-hidden="true" [icon]="menu.icon" />
        </span>
        <l-text t="body2" tone="mist90" strong="medium" class="min-w-0 flex-1">
          {{ menu.title }}
        </l-text>
        <span
          class="shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide bg-white/15 text-white/80"
        >
          WIP
        </span>
      </span>
    } @else {
      <a
        class="flex w-full cursor-pointer items-center gap-2.5 rounded-lg border-r-4 border-transparent px-3 py-2 no-underline transition-all duration-300 ease-out motion-reduce:transition-none"
        (click)="toggleMenu(index); closeMobileMenu()"
        [routerLink]="menu.link"
        [ngClass]="
          isMenuActive(menu)
            ? 'bg-primary-100 text-primary-500 border-primary-500'
            : 'text-white/95 hover:bg-white/10 border-transparent'
        "
        [attr.aria-current]="isMenuActive(menu) ? 'page' : null"
        [attr.aria-label]="menu.title"
      >
        <span class="flex h-5 w-5 shrink-0 items-center justify-center transition-colors duration-300 ease-out motion-reduce:transition-none">
          <l-icon
            [ngClass]="isMenuActive(menu) ? 'text-primary-500' : 'text-primary-200'"
            class="text-[18px] leading-none transition-colors duration-300 ease-out motion-reduce:transition-none"
            aria-hidden="true"
            [icon]="menu.icon"
          />
        </span>
        <l-text
          t="body2"
          [tone]="isMenuActive(menu) ? 'primary' : 'mist90'"
          [strong]="isMenuActive(menu) ? 'semibold' : 'medium'"
          class="transition-colors duration-300 ease-out motion-reduce:transition-none"
        >
          {{ menu.title }}
        </l-text>
      </a>
    }
  </ng-template>
